import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHypertrackerHeatmapMenuMobileIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.00001 2C8.44445 3.77778 9.33334 5.22222 10.6667 6.33333C12 7.44444 12.6667 8.66667 12.6667 10C12.6667 11.2377 12.175 12.4247 11.2998 13.2998C10.4247 14.175 9.23769 14.6667 8.00001 14.6667C6.76233 14.6667 5.57535 14.175 4.70018 13.2998C3.82501 12.4247 3.33334 11.2377 3.33334 10C3.33334 9.27877 3.56727 8.57699 4.00001 8C4.00001 8.44203 4.1756 8.86595 4.48817 9.17851C4.80073 9.49107 5.22465 9.66667 5.66668 9.66667C6.1087 9.66667 6.53263 9.49107 6.84519 9.17851C7.15775 8.86595 7.33334 8.44203 7.33334 8C7.33334 6.66667 6.33334 6 6.33334 4.66667C6.33334 3.77778 6.8889 2.88889 8.00001 2Z",
		stroke: "#1A1B23",
		strokeWidth: 1.33333,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.00001 2C8.44445 3.77778 9.33334 5.22222 10.6667 6.33333C12 7.44444 12.6667 8.66667 12.6667 10C12.6667 11.2377 12.175 12.4247 11.2998 13.2998C10.4247 14.175 9.23769 14.6667 8.00001 14.6667C6.76233 14.6667 5.57535 14.175 4.70018 13.2998C3.82501 12.4247 3.33334 11.2377 3.33334 10C3.33334 9.27877 3.56727 8.57699 4.00001 8C4.00001 8.44203 4.1756 8.86595 4.48817 9.17851C4.80073 9.49107 5.22465 9.66667 5.66668 9.66667C6.1087 9.66667 6.53263 9.49107 6.84519 9.17851C7.15775 8.86595 7.33334 8.44203 7.33334 8C7.33334 6.66667 6.33334 6 6.33334 4.66667C6.33334 3.77778 6.8889 2.88889 8.00001 2Z",
		stroke: "white",
		strokeOpacity: .5,
		strokeWidth: 1.33333,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgHypertrackerHeatmapMenuMobileIcon;
